import { AppBar, Button, Typography } from "@mui/material";

import { Fragment, useContext } from "react";

import TabbedView from "../../components/lists/TabbedView/TabbedView";
import TabbedViewPage from "../../components/lists/TabbedView/TabbedViewPage";
import flex from "../../styles/flex";
import { SessionContext } from "../../utility/useSession";
import PimTransactionsView from "../mobile/devices_admin/PimTransactionsView";
import CredentialManager from "./CredentialManager";
import CustomerManager from "./CustomerManager";
import IngestionView from "./IngestionView";
import { IdentityProvidersPage } from "./IdentityProviders/ListPage";
import { useTranslation } from "react-i18next";

const AdminPage = () => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();

  return (
    <Fragment>
      <AppBar position="static" color="primary">
        <div style={{ padding: 20 }}>
          <div style={flex.flexRows}>
            <div style={flex.flexFill}>
              <Typography variant="h6">{t("admin.title")}</Typography>
            </div>
            <div>
              <Button
                color="inherit"
                onClick={() => {
                  session.logout();
                }}
              >
                {t("menuItems.logout")}
              </Button>
            </div>
          </div>
        </div>
      </AppBar>
      <div style={{ padding: 20, textAlign: "center" }}>
        <div
          style={{
            width: "100%",
            maxWidth: 1200,
            display: "inline-block",
            textAlign: "left",
          }}
        >

          <TabbedView animated={false}>
            <TabbedViewPage title={t("admin.customers")}>
              <CustomerManager />
            </TabbedViewPage>
            <TabbedViewPage title={t("settings.users")}>
              <CredentialManager />
            </TabbedViewPage>
            <TabbedViewPage title={t("settings.ingestion")}>
              <IngestionView />
            </TabbedViewPage>
            <TabbedViewPage title={t("admin.deviceTransactions")}>
              <PimTransactionsView />
            </TabbedViewPage>
            <TabbedViewPage title={t("menuItems.insights")}>
              <div>
                Insights Settings
              </div>
            </TabbedViewPage>
            <TabbedViewPage title={t("admin.identityProviders.form.title_many")}>
              <IdentityProvidersPage />
            </TabbedViewPage>
          </TabbedView>
        </div>
      </div>
    </Fragment>
  );
};

export default AdminPage;
